export const BOX_SHADOW = '0 1px 1px 0 rgba(0, 0, 0, 0.1)'
